export const getPageType = () => {
  if (typeof window !== 'undefined' && window.location) {
    const { pathname } = window.location;

    switch (true) {
      case pathname === '/':
        return 'homepage';
      default:
        return 'landing';
    }
  }

  return 'unknown page';
};
